var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in" } },
    [
      _vm.loading
        ? _c("loader")
        : _c(
            "form",
            {
              staticClass: "quotetool__step",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submitForm.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "container" }, [
                _c("h2", { staticClass: "quotetool__step-heading" }, [
                  _vm._v(_vm._s(_vm.labels.stepTwoTitle)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "quotetool__step-form-container" },
                  [
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.error
                        ? _c("p", { staticClass: "error" }, [
                            _vm._v(_vm._s(_vm.error)),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: {
                          "form-group--error": _vm.$v.waterSitesCount.$error,
                        },
                      },
                      [
                        _c("label", { attrs: { for: "sitesCount" } }, [
                          _vm._v(
                            _vm._s(_vm.labels.stepTwoNumberOfSitesLabel) + "*"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-xs-12 col-sm-4" }, [
                            _c("div", { staticClass: "custom-select" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.waterSitesCount,
                                      expression: "waterSitesCount",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { id: "sitesCount" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.waterSitesCount = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("1"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v("2"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "3" } }, [
                                    _vm._v("3"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "4" } }, [
                                    _vm._v("4"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "5" } }, [
                                    _vm._v("5"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "6" } }, [
                                    _vm._v("More than 5"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.$v.waterSitesCount.required
                      ? _c("div", { staticClass: "error" }, [
                          _vm._v("Site count is required"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.labels.stepTwoSiteHelpText),
                      },
                    }),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.waterSitesCount < 6
                      ? _c(
                          "div",
                          _vm._l(_vm.waterSites, function (site, index) {
                            return _c("water-site", {
                              key: index,
                              ref: "site" + index,
                              refInFor: true,
                              attrs: {
                                index: index,
                                value: site,
                                "has-reference-number": _vm.hasReferenceNumber,
                              },
                              on: { input: _vm.updateSiteDetails },
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.continueQuoteToolJourney
                      ? _c("div", [
                          _c("div", { staticClass: "checkbox" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.useCustomBillingAddress,
                                    expression: "useCustomBillingAddress",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  value: true,
                                  checked: Array.isArray(
                                    _vm.useCustomBillingAddress
                                  )
                                    ? _vm._i(
                                        _vm.useCustomBillingAddress,
                                        true
                                      ) > -1
                                    : _vm.useCustomBillingAddress,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.useCustomBillingAddress,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = true,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.useCustomBillingAddress =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.useCustomBillingAddress = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.useCustomBillingAddress = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.labels
                                      .stepTwoUseCustomBillingCheckboxLabel
                                  ) +
                                  "\n                            "
                              ),
                              _c("span", { staticClass: "checkmark" }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.useCustomBillingAddress
                            ? _c(
                                "div",
                                [
                                  _c("postcode-lookup", {
                                    ref: "postcodeLookup",
                                    model: {
                                      value: _vm.customBillingAddress,
                                      callback: function ($$v) {
                                        _vm.customBillingAddress = $$v
                                      },
                                      expression: "customBillingAddress",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "checkbox",
                              class: {
                                "form-group--error":
                                  _vm.$v.confirmationReceived.$error,
                              },
                            },
                            [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.confirmationReceived,
                                      expression: "confirmationReceived",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: true,
                                    checked: Array.isArray(
                                      _vm.confirmationReceived
                                    )
                                      ? _vm._i(_vm.confirmationReceived, true) >
                                        -1
                                      : _vm.confirmationReceived,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.confirmationReceived,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = true,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.confirmationReceived =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.confirmationReceived = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.confirmationReceived = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.labels.stepTwoConfirmBillingLabel
                                    ) +
                                    "*\n                            "
                                ),
                                _c("span", { staticClass: "checkmark" }),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.$v.confirmationReceived.required
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v("Confirmation is required"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.confirmationReceived.isTrue
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v("Confirmation is required"),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn--chevron",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.submitForm.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.submitButtonText))]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "section--light-blue" }, [
                _c("div", { staticClass: "container container--3-col" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 text-center" }, [
                      _c("h2", [_vm._v(_vm._s(_vm.labels.stepTwoUSPHeading))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                      _c(
                        "div",
                        { staticClass: "container--3-col__col-wrapper" },
                        [
                          _c("img", { attrs: { src: "/dist/img/drop-1.png" } }),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.labels.stepTwoUSPOne),
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                      _c(
                        "div",
                        { staticClass: "container--3-col__col-wrapper" },
                        [
                          _c("img", { attrs: { src: "/dist/img/drop-2.png" } }),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.labels.stepTwoUSPTwo),
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                      _c(
                        "div",
                        { staticClass: "container--3-col__col-wrapper" },
                        [
                          _c("img", { attrs: { src: "/dist/img/drop-3.png" } }),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.labels.stepTwoUSPThree),
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }